import axios from 'axios'
import {envVars} from '@/envVars.ts'

/**
 * Dedicated axios instance for the public "request account deletion" page.
 *
 * Why this is NOT the global `@/axiosInstance`:
 *
 * 1. Token source. The global instance reads the access token from
 *    `localStorage`. This page instead receives the token on-the-fly from the
 *    URL hash (it is opened inside a mobile WebView) and keeps it ONLY in
 *    component state — it must never be written to `localStorage`.
 *
 * 2. Harmful side effects. The global instance's response interceptor, on a
 *    401, attempts a token refresh and then calls `useAuthStore.reset()`, which
 *    clears `localStorage` and tears down the logged-in web session. On this
 *    public page that behaviour is wrong: an invalid/expired token should simply
 *    surface an error, never wipe an unrelated session that may share the same
 *    browser storage.
 *
 * This instance therefore has NO interceptors. The bearer token is applied
 * per-request from the page's state — see `accountDeletion.http.ts`.
 */
export const accountDeletionAxios = axios.create({
    baseURL: envVars.VITE_API_ENDPOINT,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
})
